
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M20.74 6.86L22 15.2c.51 3.65-2 6.97-5.4 7H7.34c-3.34 0-5.88-3.35-5.34-7l1.26-8.34a5.61 5.61 0 015.34-5h6.8a5.61 5.61 0 015.34 5zm-4.11 13.81a3.66 3.66 0 002.77-1.33 4.88 4.88 0 001.09-3.92l-1.23-8.34a4.11 4.11 0 00-3.86-3.75H8.6a4.11 4.11 0 00-3.86 3.75l-1.23 8.34a4.88 4.88 0 001.09 3.92 3.66 3.66 0 002.77 1.33h9.26z"}}),_c('path',{attrs:{"d":"M15.15 7.06a.75.75 0 00-.75.75 2.4 2.4 0 11-4.8 0 .75.75 0 00-1.5 0 3.9 3.9 0 007.8 0 .76.76 0 00-.75-.75z"}})])
          )
        }
      }
    